module.exports = require('../internals/global');



//////////////////
// WEBPACK FOOTER
// C:/wamp64/www/lepetitsalon/wp-content/themes/digitalcover/node_modules/core-js/internals/path.js
// module id = 37
// module chunks = 0